import { createAxiosClient } from '../axiosDefaults';
const SELF_EVALUATION_PATH = 'self-evaluation';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    getSelfEvaluation,
    getSelfEvaluationPreview,
    postReevaluation,
    createSelfEvaluation,
    updateSelfEvaluation,
    updateEvaluationStep,
    updateACIEvaluationStep,
    finalizeSelfEvaluation,
    updateSelfEvaluationImage,
    removeSelfEvaluationImage,
    identifyVehicleByLicensePlate,
    patchSelfEvaluation,
    savePartialSelfEvaluation,
    updateSelfEvaluationProperties,
    getReevaluationApplicability,
    getVinVerificationOptions,
    getAutopricingElegibility,
    updateSelfEvaluationVin,
    createEssentialSelfEvaluation,
    createSelfEvaluationAssumption,
    createAciAuction,
    createSelfEvaluationDamage,
    deleteSelfEvaluationDamage,
    createACIRedirect,
    getSelfEvaluationDamage,
    updateSelfEvaluationDamage,
    deleteSelfEvaluationDamageImage
  };

  function getSelfEvaluation(carleadHash) {
    return axiosInstance.get(SELF_EVALUATION_PATH + "/" + carleadHash + "/").then(res => res.data);
  }

  function getSelfEvaluationPreview(carleadHash) {
    return axiosInstance.get(SELF_EVALUATION_PATH + "/" + carleadHash + "/preview").then(res => res.data);
  }

  function postReevaluation(carleadHash, data) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/reevaluation", data).then(res => res.data);
  }

  function createSelfEvaluation(carleadHash, data) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash, { ...data,
      carLeadHash: carleadHash
    }).then(res => res.data);
  }

  function updateSelfEvaluation(carleadHash, data) {
    return axiosInstance.put(SELF_EVALUATION_PATH + "/" + carleadHash, data);
  }

  function patchSelfEvaluation(carleadHash, data) {
    return axiosInstance.patch(SELF_EVALUATION_PATH + "/" + carleadHash, data, {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    });
  }

  function savePartialSelfEvaluation(carleadHash, data) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/partial-save", data, {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    });
  }

  function finalizeSelfEvaluation(carleadHash, data) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/self-inspection", data);
  }

  function updateEvaluationStep(carleadHash, step) {
    return axiosInstance.put(SELF_EVALUATION_PATH + "/" + carleadHash + "/funnel-step", {
      value: step
    });
  }

  function updateACIEvaluationStep(carleadHash, data) {
    return axiosInstance.put(SELF_EVALUATION_PATH + "/" + carleadHash + "/aci-funnel-step", data);
  }

  function updateSelfEvaluationImage(carleadHash, data) {
    return axiosInstance.put(SELF_EVALUATION_PATH + "/" + carleadHash + "/images", data);
  }

  function removeSelfEvaluationImage(carleadHash, id) {
    return axiosInstance.delete(SELF_EVALUATION_PATH + "/" + carleadHash + "/images/" + id);
  }

  function identifyVehicleByLicensePlate(carleadHash, licensePlate) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/vehicle-identification", {
      licensePlate
    });
  }

  function updateSelfEvaluationProperties(carleadHash, payload) {
    return axiosInstance.put(SELF_EVALUATION_PATH + "/" + carleadHash + "/properties", payload);
  }

  function getReevaluationApplicability(carleadHash, params) {
    return axiosInstance.get(SELF_EVALUATION_PATH + "/" + carleadHash + "/reevaluation/applicability", {
      params
    });
  }

  function getVinVerificationOptions(carleadHash) {
    return axiosInstance.get(SELF_EVALUATION_PATH + "/" + carleadHash + "/vin-verification-options");
  }

  function getAutopricingElegibility(carleadHash) {
    return axiosInstance.get(SELF_EVALUATION_PATH + "/" + carleadHash + "/autopricing/eligibility");
  }

  function updateSelfEvaluationVin(carleadHash, vin) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/vin", {
      vin
    });
  }

  function createEssentialSelfEvaluation(carleadHash, data) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/essential", data);
  }

  function createSelfEvaluationAssumption(carleadHash) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/assumption", {});
  }

  function createAciAuction(carleadHash, data) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/aci-auction-start", {});
  }

  function createSelfEvaluationDamage(carleadHash, payload) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/damages", payload);
  }

  function updateSelfEvaluationDamage(carleadHash, payload) {
    return axiosInstance.put(SELF_EVALUATION_PATH + "/" + carleadHash + "/damages", payload);
  }

  function deleteSelfEvaluationDamage(carleadHash, damageId) {
    return axiosInstance.delete(SELF_EVALUATION_PATH + "/" + carleadHash + "/damages/" + damageId);
  }

  function createACIRedirect(carleadHash) {
    return axiosInstance.post(SELF_EVALUATION_PATH + "/" + carleadHash + "/aci-mobile-redirect", {});
  }

  function getSelfEvaluationDamage(id) {
    return axiosInstance.get(SELF_EVALUATION_PATH + "/damages/" + id).then(res => res.data);
  }

  function deleteSelfEvaluationDamageImage(carleadHash, damageId) {
    return axiosInstance.delete(SELF_EVALUATION_PATH + "/" + carleadHash + "/damages/images/" + damageId);
  }
}